import React from "react";
import { Link } from "react-router-dom";
import "./PrivacyPolicy.css";

export const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-page">
      <div className="privacy-container">
        <Link
          to="/"
          style={{
            display: "inline-block",
            marginBottom: "20px",
            padding: "10px 20px",
            backgroundColor: "#608dfd",
            color: "#fff",
            textDecoration: "none",
            borderRadius: "4px",
            fontFamily: '"Open Sans", sans-serif',
            fontSize: "14px",
            fontWeight: 500,
            transition: "all 0.3s ease",
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = "#5ca9fb";
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = "#608dfd";
          }}
        >
          <i className="fa fa-arrow-left" style={{ marginRight: "8px" }}></i>
          Back to Home
        </Link>
        <h1 className="privacy-title">PRIVACY POLICY</h1>

        <div className="privacy-dates">
          <p>
            <strong>Effective Date:</strong> January 25, 2026
          </p>
          <p>
            <strong>Last Updated:</strong> January 25, 2026
          </p>
        </div>

        <hr className="privacy-divider" />

        <section className="privacy-section">
          <h2 className="privacy-heading">Introduction</h2>
          <p>
            Sikh Motorcycle Riders Canada ("we," "us," "our") is committed to
            protecting the privacy of users ("you," "your"). This Privacy Policy
            explains what data we collect, how it is used, stored, shared, and
            your rights with respect to that data.
          </p>
          <p>
            By accessing or using our website, services, or content, you agree
            to the terms and practices described in this Privacy Policy.
          </p>
        </section>

        <hr className="privacy-divider" />

        <section className="privacy-section">
          <h2 className="privacy-heading">1. Information We Collect</h2>

          <h3 className="privacy-subheading">
            1.1 Personal Information You Provide
          </h3>
          <p>
            We may collect personal information when you register, submit a
            form, join a newsletter, or otherwise interact with the site. This
            typically includes:
          </p>
          <ul className="privacy-list">
            <li>Name</li>
            <li>Email address</li>
            {/* <li>Username and password</li> */}
            <li>Profile information (optional)</li>
            <li>Comments, messages, or community posts</li>
            <li>Photo or media content you upload</li>
          </ul>

          <h3 className="privacy-subheading">
            1.2 Automatically Collected Data
          </h3>
          <p>
            We collect usage and technical data through cookies, analytics, and
            server logs:
          </p>
          <ul className="privacy-list">
            <li>IP address</li>
            <li>Browser type and version</li>
            <li>Device information</li>
            <li>Pages visited and interaction timestamps</li>
            <li>Referring URL</li>
          </ul>
        </section>

        <hr className="privacy-divider" />

        <section className="privacy-section">
          <h2 className="privacy-heading">2. How We Use Your Information</h2>
          <p>We use your information to:</p>
          <ul className="privacy-list">
            <li>Provide and improve the website and services</li>
            <li>Personalize your experience</li>
            <li>Enable community features (forums, comments, user profiles)</li>
            <li>Send transactional messages and notifications</li>
            <li>
              Administer contests, promotions, newsletters (with your consent)
            </li>
            <li>
              Detect, prevent, and respond to abuse, fraud, and security risks
            </li>
            <li>Comply with legal obligations</li>
          </ul>
        </section>

        <hr className="privacy-divider" />

        <section className="privacy-section">
          <h2 className="privacy-heading">
            3. Cookies and Tracking Technologies
          </h2>
          <p>We use cookies and similar technologies to:</p>
          <ul className="privacy-list">
            <li>Remember preferences and login state</li>
            <li>Analyze site performance and user behavior</li>
            <li>Serve relevant content</li>
          </ul>
          <p>
            You can manage cookie settings through your browser; however,
            disabling cookies may limit functionality.
          </p>
        </section>

        <hr className="privacy-divider" />

        <section className="privacy-section">
          <h2 className="privacy-heading">4. Information Sharing</h2>
          <p>
            We may share your information under the following circumstances:
          </p>
          <ul className="privacy-list">
            <li>
              <strong>Service Providers:</strong> With third parties who help
              operate the site (hosting, analytics, email services).
            </li>
            <li>
              <strong>Legal Compliance:</strong> When required by law, court
              order, subpoena, or government request.
            </li>
            <li>
              <strong>Protection of Rights:</strong> To protect our rights,
              users, or others.
            </li>
            <li>
              <strong>Consent:</strong> With your explicit consent.
            </li>
          </ul>
          <p>
            We do <strong>not sell your personal information</strong> to
            advertisers or unaffiliated third parties.
          </p>
        </section>

        <hr className="privacy-divider" />

        <section className="privacy-section">
          <h2 className="privacy-heading">5. Third-Party Links and Services</h2>
          <p>
            Our site may contain links to external websites with independent
            privacy practices. We are not responsible for the content or
            practices of those sites.
          </p>
        </section>

        <hr className="privacy-divider" />

        <section className="privacy-section">
          <h2 className="privacy-heading">6. Data Security</h2>
          <p>
            We implement reasonable security measures (technical and
            administrative) to protect data. However, no system is fully secure;
            transmission over the internet carries inherent risks.
          </p>
        </section>

        <hr className="privacy-divider" />

        <section className="privacy-section">
          <h2 className="privacy-heading">7. Children's Privacy</h2>
          <p>
            Our services are not directed at children under 16. We do not
            knowingly collect personal information from children under 16. If
            you believe we have such data, contact us to request deletion.
          </p>
        </section>

        <hr className="privacy-divider" />

        <section className="privacy-section">
          <h2 className="privacy-heading">8. Your Rights and Choices</h2>
          <p>Depending on your location:</p>
          <ul className="privacy-list">
            <li>Access and correct your personal information</li>
            <li>Request deletion of your account data</li>
            <li>Opt out of marketing communications</li>
          </ul>
          <p>To exercise rights, contact us as listed below.</p>
        </section>

        <hr className="privacy-divider" />

        <section className="privacy-section">
          <h2 className="privacy-heading">9. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy periodically. The "Last Updated"
            date will reflect changes. Continued use after changes constitutes
            acceptance.
          </p>
        </section>

        <hr className="privacy-divider" />

        <section className="privacy-section">
          <h2 className="privacy-heading">10. Contact Us</h2>
          <p>If you have questions or requests, please contact:</p>
          <p>
            <strong>Email:</strong> <em>info@SikhMotorcycleRiders.com</em>
          </p>
          <p>
            <strong>Website:</strong>{" "}
            <a
              href="https://sikhmotorcycleriders.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://sikhmotorcycleriders.com/
            </a>
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
